module.exports = __webpack_public_path__ + "static/img/VA.af54df2e.png";